import React, { useContext } from "react";
import InputName from "../inputs/InputName";
import InputPosition from "../inputs/InputPosition";
import InputLogo from "../inputs/InputLogo";
import ZoomBack from "./ZoomBack";
import { ColorContext } from "../../contexts/ColorContext";

const ImagePreview = () => {
  const { colors } = useContext(ColorContext);
  const styleObj = {
    backgroundColor: colors.backgroundColor,
    '--placeholder-color': colors.textColor
  }
  const nameStyleObj = {
    marginLeft: '90px',
    paddingLeft: 0,
    color: colors.textColor
  }
  const positionStyleObj = {
    marginLeft: '90px',
    paddingLeft: 0,
    color: colors.textColor,
    fontSize: '1.5em'
  }
  const logoStyleObj = {
    textAlign: 'right',
    paddingRight: 0,
    color: colors.logoColor,
    '--placeholder-color': colors.logoColor
  }
  return (
    <div className="image-preview" style={styleObj}>
      <div className="image-preview-editable">
        <div className="image-preview-name">
          <InputName name="James From" nameStyleObj={nameStyleObj} />
          <InputPosition position="Software Engineer" positionStyleObj={positionStyleObj} />
        </div>
        <div className="image-preview-logo">
          <InputLogo logo="LDN Ltd." logoStyleObj={logoStyleObj}/>
        </div>
      </div>
      <div className="zoomback">
        <ZoomBack />
      </div>
    </div>
  )
};

export default ImagePreview;
